// Die EINZIGE Datei, die window.* schreiben darf (Mixed-Mode-Bruecke,
// Plan sharded-hatching-clover Phase 2). Jedes hier publizierte Symbol
// existiert, weil noch mindestens ein Legacy-Classic-Skript es als Global
// referenziert - mit jeder nach ESM konvertierten Datei schrumpft diese
// Liste, bis sie leer ist.
//
// Muster:
//   import { CFoo } from './services/CFoo.js';
//   window.CFoo = CFoo; // Konsumenten: CLS_CBar.js, CMP_CBaz.js (grep-Stand JJJJ-MM-TT)

// ==== ESM-Welle 5c: FNC_main.js - der Legacy-Boot selbst (20.08.2026) ====
// BEWUSST ERSTER Import. Die Huelle legt beim Evaluieren die Boot-Globals an
// (window.POS/log/fs/require/CryptoJS/rs/Buffer/qrcode/now/silent/...) und
// registriert $(document).ready(run). Als Classic-Skript stand FNC_main.js
// VOR dem Bundle; erster Import stellt dieselbe Reihenfolge her: die
// Properties existieren, bevor irgendein anderes Modul evaluiert, und der
// ready-Handler von run() bleibt der erste in jQuerys Queue (vor dem
// combobox-Widget aus core/tools-fnc.js) - exakt wie bisher.
import { runtest, run, ensurePrivileges, clearCache, include, initLogging, init,
         unInit, parseURLParams, testing, scaleImageData } from './core/main-fnc.js';

import { TimeRecordDomain } from './domain/timerecord.js';
// Konsumenten: CMP_CTimeRecord.js (Screen) + CLS_CSessionHandler.js indirekt
// ueber die Screen-Methoden (Stand 20.8.2026). Liefert NATIVE Promises -
// nie in $.when() stecken, .then() direkt benutzen.
window.TimeRecordDomain = TimeRecordDomain;

import { StockDomain } from './domain/stock.js';
// Konsumenten: CLS_CBonEntryOps.js acceptDelivery (Stand 20.8.2026).
window.StockDomain = StockDomain;

import { BalancingDomain } from './domain/balancing.js';
// Konsumenten: CMP_CPosBalancing.js (Stand 20.8.2026).
window.BalancingDomain = BalancingDomain;

import { DialogService } from './services/dialog.js';
// Konsumenten: CLS_CSQLite.js (DB-Fehler-Dialog, Stufe 2a; Stand 20.8.2026).
window.DialogService = DialogService;

import { CTools } from './core/tools.js';
import { CSound } from './core/sound.js';
import { CTimeOut } from './core/timeout.js';
import { hex_md5, b64_md5, str_md5, hex_hmac_md5, b64_hmac_md5, str_hmac_md5 } from './core/md5.js';
// Konsumenten (Stand 20.8.2026): CLS_CPOS.js konstruiert CTools/CSound/
// CTimeOut (POS.tools/.sound/.timeout); hex_md5: CMP_CLoginScreen.js,
// CMP_CPosBalancing.js, CLS_CSessionHandler.js u.a.
window.CTools = CTools;
window.CSound = CSound;
window.CTimeOut = CTimeOut;
window.hex_md5 = hex_md5;
window.b64_md5 = b64_md5;
window.str_md5 = str_md5;
window.hex_hmac_md5 = hex_hmac_md5;
window.b64_hmac_md5 = b64_hmac_md5;
window.str_hmac_md5 = str_hmac_md5;

import { CCache } from './core/cache.js';
import { CLanguage } from './core/language.js';
// Konsumenten (Stand 20.8.2026): CLS_CPOS.js konstruiert POS.cache/POS.lang.
window.CCache = CCache;
window.CLanguage = CLanguage;

import { CFileHandler } from './core/filehandler.js';
import { CXmlHandler } from './core/xmlhandler.js';
// Konsumenten (Stand 20.8.2026): fs = new CFileHandler() in FNC_main.js
// ($(document).ready - laeuft NACH den Modulen), CXmlHandler in allen
// Screen-prepare()-Methoden und CComponent.setStyleFromXML.
window.CFileHandler = CFileHandler;
window.CXmlHandler = CXmlHandler;

import { CSQlite } from './core/sqlite.js';
import { CFileLogging } from './core/filelogging.js';
// Konsumenten (Stand 20.8.2026): POS.SQLiteCon = new CSQlite(...) im
// CPOS-Konstruktor, log = new CFileLogging(...) in FNC_main initLogging()
// - beides Laufzeit, nach Modul-Init.
window.CSQlite = CSQlite;
window.CFileLogging = CFileLogging;

import * as FNCTools from './core/tools-fnc.js';
// Konsumenten (Stand 20.8.2026): praktisch alle Classic-Skripte (combine,
// fix2Decimals, float2StringD2, execute, dump, ...).
window.combine = FNCTools.combine;
window.toSource = FNCTools.toSource;
window.getRandomNumber = FNCTools.getRandomNumber;
window.float2formatString = FNCTools.float2formatString;
window.fix2Decimals = FNCTools.fix2Decimals;
window.convert2Hex = FNCTools.convert2Hex;
window.float2StringD2 = FNCTools.float2StringD2;
window.remEuropeanComma = FNCTools.remEuropeanComma;
window.remAmericanComma = FNCTools.remAmericanComma;
window.sdump = FNCTools.sdump;
window.dump = FNCTools.dump;
window.fdumpsub = FNCTools.fdumpsub;
window.fdump = FNCTools.fdump;
window.expandInteger = FNCTools.expandInteger;
window.umlauToEntity = FNCTools.umlauToEntity;
window.entityToUmlau = FNCTools.entityToUmlau;
window.htmlEncode = FNCTools.htmlEncode;
window.htmlDecode = FNCTools.htmlDecode;
window.toLowerCaseButFirst = FNCTools.toLowerCaseButFirst;
window.getNow = FNCTools.getNow;
window.measure = FNCTools.measure;
window.decToHexa = FNCTools.decToHexa;
window.formatDateString = FNCTools.formatDateString;
window.formatTimeString = FNCTools.formatTimeString;
window.currentDateString = FNCTools.currentDateString;
window.currentTimeString = FNCTools.currentTimeString;
window.cent2Euro = FNCTools.cent2Euro;
window.DateToString = FNCTools.DateToString;
window.b64t2d = FNCTools.b64t2d;
window.lrtrim = FNCTools.lrtrim;
window.execute = FNCTools.execute;
window.executeCommand = FNCTools.executeCommand;
window.getMyIP = FNCTools.getMyIP;
window.getValueFromINIXML = FNCTools.getValueFromINIXML;
window.checkBusyDates = FNCTools.checkBusyDates;


import { CReceiptPrinter } from './domain/bon/receiptprinter.js';
import { CBunchOps } from './domain/bon/bunchops.js';
import { CBonRenderer } from './domain/bon/bonrenderer.js';
import { CBonEntryOps } from './domain/bon/bonentryops.js';
import { CRebateEngine } from './domain/bon/rebateengine.js';
import { CPaymentProcessor } from './domain/bon/paymentprocessor.js';
// Konsumenten (Stand 20.8.2026): CLS_CBonManager.js-Konstruktor bindet
// alle sechs als Mixins (new + bind der delegierten Methoden).
window.CReceiptPrinter = CReceiptPrinter;
window.CBunchOps = CBunchOps;
window.CBonRenderer = CBonRenderer;
window.CBonEntryOps = CBonEntryOps;
window.CRebateEngine = CRebateEngine;
window.CPaymentProcessor = CPaymentProcessor;


import { CBonManager, CBonEntry } from './domain/bon/bonmanager.js';
// Konsumenten (Stand 20.8.2026): CMP_CMainPOS.js konstruiert den
// CBonManager; CBonEntry wird u.a. von CLS_CBonTransaction.js beim
// Bon-Laden konstruiert.
window.CBonManager = CBonManager;
window.CBonEntry = CBonEntry;

import { CBonTransaction } from './domain/bon/bontransaction.js';
// Konsumenten (Stand 20.8.2026): window.Trans im CBonManager-Konstruktor,
// dazu lokale new-Instanzen in CLS_CPOS.js, CLS_CDataExport.js,
// CLS_CRunClient.js.
window.CBonTransaction = CBonTransaction;


import { CEANManager } from './pos/eanmanager.js';
import { CBarcodeReader } from './pos/barcodereader.js';
import { CVoucher, CBalanceDataSet, CCreditBalanceVoucher, CCreditCardVoucher, CDebitBalanceVoucher, CDebitVoucher } from './pos/voucher.js';
import { CThresholdPrice } from './pos/thresholdprice.js';
import { CReports } from './pos/posreports.js';
import { CDataImport } from './pos/dataimport.js';
import { CDataExport } from './pos/dataexport.js';
import { CPrinter } from './pos/printer.js';
import { CDisplay } from './pos/display.js';
import { CCashbox } from './pos/cashbox.js';
// Konsumenten (Stand 20.8.2026): CLS_CPOS.js/Screens konstruieren die
// Serviceklassen zur Laufzeit; die Voucher-Nebenklassen brauchen
// CLS_CBankomat.js + CLS_CZVTBankomat.js (noch Classic).
window.CEANManager = CEANManager;
window.CBarcodeReader = CBarcodeReader;
window.CVoucher = CVoucher;
window.CBalanceDataSet = CBalanceDataSet;
window.CCreditBalanceVoucher = CCreditBalanceVoucher;
window.CCreditCardVoucher = CCreditCardVoucher;
window.CDebitBalanceVoucher = CDebitBalanceVoucher;
window.CDebitVoucher = CDebitVoucher;
window.CThresholdPrice = CThresholdPrice;
window.CReports = CReports;
window.CDataImport = CDataImport;
window.CDataExport = CDataExport;
window.CPrinter = CPrinter;
window.CDisplay = CDisplay;
window.CCashbox = CCashbox;


import { CSessionHandler } from './pos/sessionhandler.js';
import { CUserRights } from './pos/userrights.js';
import { CInfoIcons } from './pos/infoicons.js';
import { CDataListener } from './netcomm/datalistener.js';
import { CHelloAgainAPI } from './netcomm/helloagain.js';
import { CInputStream } from './netcomm/inputstream.js';
import { COutputStream } from './netcomm/outputstream.js';
import { CServerInterface } from './netcomm/serverinterface.js';
import { CReceipt } from './receipt/receipt.js';
import { CReceiptTransaction } from './receipt/receipttransaction.js';
import { CSmartcard } from './receipt/smartcard.js';
import { CWebservice } from './receipt/webservice.js';
// Konsumenten (Stand 20.8.2026): CPOS/Screens/Bankomat (noch Classic)
// konstruieren diese Klassen zur Laufzeit; "add" war schon im Classic-
// Modus ein window-Global aus CLS_CReceipt.js (Status quo erhalten).
window.CSessionHandler = CSessionHandler;
window.CUserRights = CUserRights;
window.CInfoIcons = CInfoIcons;
window.CDataListener = CDataListener;
window.CHelloAgainAPI = CHelloAgainAPI;
window.CInputStream = CInputStream;
window.COutputStream = COutputStream;
window.CServerInterface = CServerInterface;
window.CReceipt = CReceipt;
window.CReceiptTransaction = CReceiptTransaction;
window.CSmartcard = CSmartcard;
window.CWebservice = CWebservice;


import { CPOS } from './pos/cpos.js';
import { CBankomatHandler, CBankomat, prepareFixedLength } from './pos/bankomat.js';
import { CZVTBankomatHandler } from './pos/zvtbankomat.js';
// Konsumenten (Stand 20.8.2026): FNC_main konstruiert POS = new CPOS()
// in $(document).ready; Bankomat-Handler werden von CPOS/CCardPaymentMode
// zur Laufzeit erzeugt. prepareFixedLength war Classic-window-Global.
window.CPOS = CPOS;
window.CBankomatHandler = CBankomatHandler;
window.CBankomat = CBankomat;
window.prepareFixedLength = prepareFixedLength;
window.CZVTBankomatHandler = CZVTBankomatHandler;


import { CMover } from './core/mover.js';
import { CEMail } from './core/email.js';
import { CStressTest } from './pos/stresstest.js';
// Konsumenten (Stand 26.8.2026): CMover konstruiert der CPOS-Konstruktor
// (POS.mover); CWirelessScanner ist am 26.8.2026 entfallen, das Geraet gibt es
// nicht mehr. CEMail: CMP_CMainPOS.js,
// CMP_CMessageWriter.js, CMP_CMessageReader.js; CStressTest:
// CMP_CLoginScreen.js. Alle vier sind noch Classic bzw. greifen als Modul
// ueber window zu (Module importieren einander in dieser Phase nicht).
window.CMover = CMover;
window.CEMail = CEMail;
window.CStressTest = CStressTest;

// ==== ESM-Welle 5a: Framework-Screens (20.08.2026) ====
// Konsumenten: CComponentBuilder.build() konstruiert Screens/Widgets per
// Klassen-Referenz zur Laufzeit; Classic-Reste + Module greifen via window zu.
// React-Strangler: CPosDisabledMode kommt aus React (frontend/src/react/screens/CPosDisabledMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CPosDisabledMode } from './react/screens/CPosDisabledMode.jsx';
// React-Strangler: CInfoMode kommt aus React (frontend/src/react/screens/CInfoMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CInfoMode } from './react/screens/CInfoMode.jsx';
// CHelpScreen ist am 23.8.2026 NEU entstanden (Benutzerhandbuch) - der
// gleichnamige Legacy-Screen war toter Code und wurde geloescht.
import { CHelpScreen } from './react/screens/CHelpScreen.jsx';
// React-Strangler: CCancelBonMode kommt aus React (frontend/src/react/screens/CCancelBonMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CCancelBonMode } from './react/screens/CCancelBonMode.jsx';
// React-Strangler: CChangesPanel kommt aus React (frontend/src/react/screens/CChangesPanel.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CChangesPanel } from './react/screens/CChangesPanel.jsx';
// React-Strangler: CScreenSaver kommt aus React (frontend/src/react/screens/CScreenSaver.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CScreenSaver } from './react/screens/CScreenSaver.jsx';
// React-Strangler: CRebatesInfoMode kommt aus React (frontend/src/react/screens/CRebatesInfoMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CRebatesInfoMode } from './react/screens/CRebatesInfoMode.jsx';
// React-Strangler: CPriceInputMode kommt aus React (frontend/src/react/screens/CPriceInputMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CPriceInputMode } from './react/screens/CPriceInputMode.jsx';
// React-Strangler: CProductSelectMode kommt aus React (frontend/src/react/screens/CProductSelectMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CProductSelectMode } from './react/screens/CProductSelectMode.jsx';
// React-Strangler: CPosReceiptList kommt aus React (frontend/src/react/screens/CPosReceiptList.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CPosReceiptList } from './react/screens/CPosReceiptList.jsx';
// React-Strangler: CMainPOS kommt aus React (frontend/src/react/screens/CMainPOS.jsx).
import { CMainPOS } from './react/screens/CMainPOS.jsx';
// React-Strangler: CCashboxPanel kommt aus React (frontend/src/react/screens/CCashboxPanel.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CCashboxPanel } from './react/screens/CCashboxPanel.jsx';
// React-Strangler: CBKFunctions kommt aus React (frontend/src/react/screens/CBKFunctions.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CBKFunctions } from './react/screens/CBKFunctions.jsx';
// React-Strangler: CTransactionShowMode kommt aus React (frontend/src/react/screens/CTransactionShowMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CTransactionShowMode } from './react/screens/CTransactionShowMode.jsx';
// React-Strangler: CInventoryPanel kommt aus React (frontend/src/react/screens/CInventoryPanel.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CInventoryPanel } from './react/screens/CInventoryPanel.jsx';
// React-Strangler: CBonSearch kommt aus React (frontend/src/react/screens/CBonSearch.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CBonSearch } from './react/screens/CBonSearch.jsx';
// React-Strangler: CTimeRecord kommt aus React (frontend/src/react/screens/CTimeRecord.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CTimeRecord } from './react/screens/CTimeRecord.jsx';
// React-Strangler: CMainPOSInfoMode kommt aus React (frontend/src/react/screens/CMainPOSInfoMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CMainPOSInfoMode } from './react/screens/CMainPOSInfoMode.jsx';
// React-Strangler: CUserFunctions kommt aus React (frontend/src/react/screens/CUserFunctions.jsx),
// Runbook: tools/REACT-STRANGLER.md. printShopsDataHelper ist mitgewandert.
import { CUserFunctions, printShopsDataHelper } from './react/screens/CUserFunctions.jsx';
// React-Strangler: CPosBalancing kommt aus React (frontend/src/react/screens/CPosBalancing.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CPosBalancing } from './react/screens/CPosBalancing.jsx';
// React-Strangler: CLoginScreen kommt aus React (frontend/src/react/screens/CLoginScreen.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CLoginScreen } from './react/screens/CLoginScreen.jsx';
// React-Strangler: COnlyPayMode kommt aus React (frontend/src/react/screens/COnlyPayMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { COnlyPayMode } from './react/screens/COnlyPayMode.jsx';
import { CPrepaidCardPayment } from './react/screens/CPrepaidCardPayment.jsx';
// React-Strangler: COtherFunctions kommt aus React (frontend/src/react/screens/COtherFunctions.jsx),
// Runbook: tools/REACT-STRANGLER.md. executeShellCommand ist mitgewandert.
import { COtherFunctions, executeShellCommand } from './react/screens/COtherFunctions.jsx';
// React-Strangler: CCancelClosedBonMode kommt aus React (frontend/src/react/screens/CCancelClosedBonMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CCancelClosedBonMode } from './react/screens/CCancelClosedBonMode.jsx';
// React-Strangler: CPersonalPurchaseMode kommt aus React (frontend/src/react/screens/CPersonalPurchaseMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CPersonalPurchaseMode } from './react/screens/CPersonalPurchaseMode.jsx';
// React-Strangler: CProductCategoriesMode kommt aus React (frontend/src/react/screens/CProductCategoriesMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CProductCategoriesMode } from './react/screens/CProductCategoriesMode.jsx';
// React-Strangler: CCustomerDataMode kommt aus React (frontend/src/react/screens/CCustomerDataMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CCustomerDataMode } from './react/screens/CCustomerDataMode.jsx';
// React-Strangler Pilot (21.08.2026): CAboutMode kommt aus React
// (frontend/src/react/screens/AboutMode.jsx), Konsument: COtherFunctions.
// aboutWindow (Main.addChild(CAboutMode)). Runbook: tools/REACT-STRANGLER.md.
import { CAboutMode } from './react/screens/AboutMode.jsx';
// React-Strangler: CCardPaymentMode kommt aus React (frontend/src/react/screens/CCardPaymentMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CCardPaymentMode } from './react/screens/CCardPaymentMode.jsx';
import { CCustomerAdmin } from './screens/customeradmin.js';
// React-Strangler: CBonSaveMode kommt aus React (frontend/src/react/screens/CBonSaveMode.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CBonSaveMode } from './react/screens/CBonSaveMode.jsx';
// React-Strangler: CPOSIDScreen kommt aus React (frontend/src/react/screens/CPOSIDScreen.jsx),
// Runbook: tools/REACT-STRANGLER.md.
import { CPOSIDScreen } from './react/screens/CPOSIDScreen.jsx';
import { CRunClient } from './netcomm/runclient.js';
import { messageboard } from './screens/messageboard.js';
import { MessageFunctions } from './screens/messages.js';
window.CPosDisabledMode = CPosDisabledMode;
window.CInfoMode = CInfoMode;
window.CHelpScreen = CHelpScreen;
window.CCancelBonMode = CCancelBonMode;
window.CChangesPanel = CChangesPanel;
window.CScreenSaver = CScreenSaver;
window.CRebatesInfoMode = CRebatesInfoMode;
window.CPriceInputMode = CPriceInputMode;
window.CProductSelectMode = CProductSelectMode;
window.CPosReceiptList = CPosReceiptList;
window.CMainPOS = CMainPOS;
window.CCashboxPanel = CCashboxPanel;
window.CBKFunctions = CBKFunctions;
window.CTransactionShowMode = CTransactionShowMode;
window.CInventoryPanel = CInventoryPanel;
window.CBonSearch = CBonSearch;
window.CTimeRecord = CTimeRecord;
window.CMainPOSInfoMode = CMainPOSInfoMode;
window.CUserFunctions = CUserFunctions;
window.printShopsDataHelper = printShopsDataHelper;
window.CPosBalancing = CPosBalancing;
window.CLoginScreen = CLoginScreen;
window.COnlyPayMode = COnlyPayMode;
window.CPrepaidCardPayment = CPrepaidCardPayment;
window.COtherFunctions = COtherFunctions;
window.executeShellCommand = executeShellCommand;
window.CCancelClosedBonMode = CCancelClosedBonMode;
window.CPersonalPurchaseMode = CPersonalPurchaseMode;
window.CProductCategoriesMode = CProductCategoriesMode;
window.CCustomerDataMode = CCustomerDataMode;
window.CAboutMode = CAboutMode;
window.CCardPaymentMode = CCardPaymentMode;
window.CCustomerAdmin = CCustomerAdmin;
window.CBonSaveMode = CBonSaveMode;
window.CPOSIDScreen = CPOSIDScreen;
window.CRunClient = CRunClient;
window.messageboard = messageboard;
window.MessageFunctions = MessageFunctions;

// ==== ESM-Welle 5b: Framework-Widgets+Kern (20.08.2026) ====
// Konsumenten: CComponentBuilder.build() konstruiert Screens/Widgets per
// Klassen-Referenz zur Laufzeit; Classic-Reste + Module greifen via window zu.
import { CComponent } from './components/component.js';
import { CHourGlass } from './components/hourglass.js';
import { CMessage } from './components/message.js';
import { CFrame } from './components/frame.js';
import { CTableBody } from './components/tablebody.js';
import { CIframe } from './components/iframe.js';
import { CDataGrid } from './components/datagrid.js';
import { CInputField } from './components/inputfield.js';
import { CLabeledInputField } from './components/labeledinputfield.js';
import { CLabeledInputField2 } from './components/labeledinputfield2.js';
import { CMultiClickNumber } from './components/multiclicknumber.js';
import { CKeyboard } from './components/keyboard.js';
import { CColumn } from './components/column.js';
import { CPre } from './components/pre.js';
import { CTabbedPushPanel } from './components/tabbedpushpanel.js';
import { CFocusElement } from './components/focuselement.js';
import { CMultiClickDate } from './components/multiclickdate.js';
import { CCaption } from './components/caption.js';
import { CNumPad } from './components/numpad.js';
import { CTextLabel } from './components/textlabel.js';
import { CMultiClickTime } from './components/multiclicktime.js';
import { CPushPanel } from './components/pushpanel.js';
import { COverlay } from './components/overlay.js';
import { CInput } from './components/input.js';
import { CImage } from './components/image.js';
import { CPagedPushPanel } from './components/pagedpushpanel.js';
import { CPushButton } from './components/pushbutton.js';
import { CContainerTable } from './components/containertable.js';
import { CContainerColumn } from './components/containercolumn.js';
import { CContainerRow } from './components/containerrow.js';
import { CTable } from './components/table.js';
import { CRow } from './components/row.js';
import { CClickNumber } from './components/clicknumber.js';
import { CContainerTableBody } from './components/containertablebody.js';
import { CEventDispatcher } from './components/eventdispatcher.js';
import { CComponentBuilder } from './components/componentbuilder.js';
window.CComponent = CComponent;
window.CHourGlass = CHourGlass;
window.CMessage = CMessage;
window.CFrame = CFrame;
window.CTableBody = CTableBody;
window.CIframe = CIframe;
window.CDataGrid = CDataGrid;
window.CInputField = CInputField;
window.CLabeledInputField = CLabeledInputField;
window.CLabeledInputField2 = CLabeledInputField2;
window.CMultiClickNumber = CMultiClickNumber;
window.CKeyboard = CKeyboard;
window.CColumn = CColumn;
window.CPre = CPre;
window.CTabbedPushPanel = CTabbedPushPanel;
window.CFocusElement = CFocusElement;
window.CMultiClickDate = CMultiClickDate;
window.CCaption = CCaption;
window.CNumPad = CNumPad;
window.CTextLabel = CTextLabel;
window.CMultiClickTime = CMultiClickTime;
window.CPushPanel = CPushPanel;
window.COverlay = COverlay;
window.CInput = CInput;
window.CImage = CImage;
window.CPagedPushPanel = CPagedPushPanel;
window.CPushButton = CPushButton;
window.CContainerTable = CContainerTable;
window.CContainerColumn = CContainerColumn;
window.CContainerRow = CContainerRow;
window.CTable = CTable;
window.CRow = CRow;
window.CClickNumber = CClickNumber;
window.CContainerTableBody = CContainerTableBody;
window.CEventDispatcher = CEventDispatcher;
window.CComponentBuilder = CComponentBuilder;

// ==== ESM-Welle 5c: FNC_main.js - Top-Level-Funktionen (20.08.2026) ====
// Konsumenten: index.html <body onUnload="unInit ();"> ist der einzige belegte
// Cross-File-Zugriff; die uebrigen wie bisher als window-Globals publiziert,
// weil die Websocket-Payloads des Zentralservers per eval ausgefuehrt werden
// (seit 25.8.2026 in lib/scripts/pos/netcomm/legacy-eval.js).
// Die Boot-VARIABLEN (POS, log, fs, ...) setzt die Huelle selbst per window.
window.runtest = runtest;
window.run = run;
window.ensurePrivileges = ensurePrivileges;
window.clearCache = clearCache;
window.include = include;
window.initLogging = initLogging;
window.init = init;
window.unInit = unInit;
window.parseURLParams = parseURLParams;
window.testing = testing;
window.scaleImageData = scaleImageData;
